import { Caption, Header, OuterContainer } from "./styles";
import styled from "styled-components";

const LogosContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  margin-top: 10px;
  padding: 20px;
  text-align: center;
`;

const LogoSection = styled.div`
  margin-bottom: 40px;
`;

const LogoLink = styled.a`
  display: inline-block;
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.8;
  }
`;

const LogoImage = styled.img`
  display: block;
  margin: 0 0 10px 0;
  height: auto;
`;

const LogoDescription = styled.div`
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  margin-top: 10px;
  color: #666;
`;

const IntroDescription = styled(LogoDescription)`
  max-width: 800px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 40px;
  font-size: 16px;
  color: #333;
`;

const SectionHeader = styled(Header)`
  font-size: 16px;
  margin-bottom: 20px;
`;

export default function Logos() {
  return (
    <OuterContainer>
      <LogosContainer>
        <Header>SENTIENTS LOGOS</Header>

        <IntroDescription>
          Click any logo to download the high-resolution file for use in press
          coverage, promotional materials, or third-party content. These logos
          may not be modified or used in a way that implies official endorsement
          or authorship by Tedbot Games.
        </IntroDescription>

        <LogoSection>
          <SectionHeader>HORIZONTAL LOGOS</SectionHeader>

          <LogoLink
            href="/logos/sentients-logo-gradient.png"
            download="sentients-logo-gradient.png"
          >
            <LogoImage
              width="400"
              height="48"
              src="/logos/sentients-logo-gradient.png"
              alt="Sentients Logo Gradient"
            />
            <LogoDescription>Gradient Logo (PNG)</LogoDescription>
          </LogoLink>

          <br />
          <br />

          <LogoLink
            href="/logos/sentients-logo-black.svg"
            download="sentients-logo-black.svg"
          >
            <LogoImage
              width="400"
              height="48"
              src="/logos/sentients-logo-black.svg"
              alt="Sentients Logo Black"
            />
            <LogoDescription>Black Logo (SVG)</LogoDescription>
          </LogoLink>

          <br />
          <br />

          <LogoLink
            href="/logos/sentients-logo-white.svg"
            download="sentients-logo-white.svg"
          >
            <LogoImage
              width="400"
              height="48"
              src="/logos/sentients-logo-white.svg"
              alt="Sentients Logo White"
              style={{ backgroundColor: "#333", padding: "15px" }}
            />
            <LogoDescription>White Logo (SVG)</LogoDescription>
          </LogoLink>
        </LogoSection>

        <LogoSection>
          <SectionHeader>SQUARE LOGOS</SectionHeader>

          <LogoLink
            href="/logos/sentients-square-logo-black.svg"
            download="sentients-square-logo-black.svg"
          >
            <LogoImage
              width="80"
              height="80"
              src="/logos/sentients-square-logo-black.svg"
              alt="Sentients Square Logo Black"
            />
            <LogoDescription>Square Black Logo (SVG)</LogoDescription>
          </LogoLink>

          <br />
          <br />

          <LogoLink
            href="/logos/sentients-square-logo-white.svg"
            download="sentients-square-logo-white.svg"
          >
            <LogoImage
              width="80"
              height="80"
              src="/logos/sentients-square-logo-white.svg"
              alt="Sentients Square Logo White"
              style={{ backgroundColor: "#333", padding: "15px" }}
            />
            <LogoDescription>Square White Logo (SVG)</LogoDescription>
          </LogoLink>
        </LogoSection>

        <Caption>GAME DESIGN BY TED HAYES</Caption>
      </LogosContainer>
    </OuterContainer>
  );
}
